var map = {
	"./RCDEMO_headerlogo.svg": 64032,
	"./RUNMYBOT_headerlogo.svg": 31740,
	"assetts/images/RCDEMO_headerlogo.svg": 64032,
	"assetts/images/RUNMYBOT_headerlogo.svg": 31740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60677;